"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionFourV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var fa_1 = require("react-icons/fa");
var Button_1 = __importDefault(require("../../../../components/Button"));
var styles_1 = require("./styles");
var globalFuncionts_1 = require("@utils/globalFuncionts");
function SectionFourV2() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var arrayCardsFour = [
        {
            icon: (0, jsx_runtime_1.jsx)(fa_1.FaClipboardCheck, {}),
            title: 'Onboarding digital',
            paragraph: 'Alta de clientes de punta a punta vía token o link, sin fricción y sin papeleo.',
            action: function () { return navigate('/solutions'); },
        },
        {
            icon: (0, jsx_runtime_1.jsx)(fa_1.FaChartLine, {}),
            title: 'Reportería y consumo',
            paragraph: 'Panel con métricas de verificaciones, consumos y resultados en tiempo real.',
            action: function () { return navigate('/solutions'); },
        },
        {
            icon: (0, jsx_runtime_1.jsx)(fa_1.FaPuzzlePiece, {}),
            title: 'Integraciones a medida',
            paragraph: 'Desarrollo de integraciones y aplicativos a medida sobre la plataforma KYC.',
            action: function () {
                (0, globalFuncionts_1.onOpenWhatsAppContactGbc)('Hola quisiera obtener más información sobre integraciones a medida');
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(styles_1.ContainerFour, { children: [(0, jsx_runtime_1.jsxs)(styles_1.FourContentWrapper, { children: [(0, jsx_runtime_1.jsxs)(styles_1.FourContentHead, { children: [(0, jsx_runtime_1.jsx)(styles_1.SectionTitle, __assign({ className: "four" }, { children: "Maximiz\u00E1 el cumplimiento de tu negocio con m\u00E1s soluciones GBC" })), (0, jsx_runtime_1.jsx)("p", { children: "Facilitamos la conexi\u00F3n entre tu negocio y tus clientes a trav\u00E9s de nuestra gama de servicios KYC." })] }), (0, jsx_runtime_1.jsx)(styles_1.ServicesWrapper, { children: arrayCardsFour.map(function (card, index) { return ((0, jsx_runtime_1.jsxs)(styles_1.ServiceFeatureCard, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "image-wrapper" }, { children: (0, jsx_runtime_1.jsx)(styles_1.IconTile, { children: card.icon }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "content-wrapper" }, { children: [(0, jsx_runtime_1.jsx)("h4", { children: card.title }), (0, jsx_runtime_1.jsx)("p", { children: card.paragraph })] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outline", color: "cyan", onClick: card.action }, { children: "M\u00E1s info" }))] }, index)); }) })] }), (0, jsx_runtime_1.jsx)(styles_1.LargeCyanImg, {})] }));
}
exports.SectionFourV2 = SectionFourV2;
